import React, { useEffect, useState } from "react";
import { Divider, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { a11yProps, TabPanel } from "../../../utils/cssStyles";
import { MENU_OPEN } from "../../../redux/actions/actions";
import ParentUserList from "./ParentUsers/user-list";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import FirstApproverUserList from "./FirstApprovers/user-list";
import { UserService } from "../../../assets/_services/user-service";
import SelfRegUsers from "./SelfregUsers";

function UserList({ role }: any) {
  const theme: any = useTheme();
  const { state } = useLocation();
  // const [firstApprovers, setFirstApprover] = useState<{ value: number | string; label: string }[]>([]);
  // const [secondApprovers, setSecondApprover] = useState<{ value: number | string; label: string }[]>([]);
  const [value, setValue] = useState<number>(state?.value || 0);

  const path = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.replaceState({}, "");
    const id = path?.pathname;
    dispatch({ type: MENU_OPEN, id });
    // fetchFirstApproverList();
    // fetchSecondApproverList();
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // const fetchFirstApproverList = () => {
  //   let formData = {
  //     role: 3,
  //   };
  //   UserService.getApproverListWithoutPagination(formData).then((response) => {
  //     if (response.isSuccess) {
  //       setFirstApprover(
  //         response.data.data.map((item: any) => ({
  //           value: item.id,
  //           label: `${item.userName} - ( ${item.companyName} )`,
  //         }))
  //       );
  //     } else {
  //       setFirstApprover([]);
  //     }
  //   });
  // };

  // const fetchSecondApproverList = () => {
  //   let formData = {
  //     role: 4,
  //   };
  //   UserService.getApproverListWithoutPagination(formData).then((response) => {
  //     if (response.isSuccess) {
  //       setSecondApprover(
  //         response.data.data.map((item: any) => ({
  //           value: item.id,
  //           label: `${item.userName} - ( ${item.companyName} )`,
  //         }))
  //       );
  //     } else {
  //       setSecondApprover([]);
  //     }
  //   });
  // };

  return (
    <Grid container justifyContent={"center"}>
      <Grid item xs={11}>
        <Divider textAlign={"center"}>
          <Typography sx={{ ...theme.typography.pageheader }}>
            <SupervisorAccountIcon fontSize="medium" /> User Management
          </Typography>
        </Divider>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Tabs variant="scrollable" value={value} onChange={handleChange} aria-label="Vertical tabs example" sx={{ mb: 2 }}>
          <Tab label="Parent Users" {...a11yProps(0)} />
          <Tab label="First Level Approver" {...a11yProps(1)} />
          <Tab label="second Level Approver" {...a11yProps(2)} />
          <Tab label="Self Reg Users" {...a11yProps(3)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <ParentUserList value={value} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <FirstApproverUserList value={value} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <FirstApproverUserList value={value} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SelfRegUsers value={value} />
        </TabPanel>
      </Grid>
    </Grid>
  );
}

export default UserList;
